<template>
  <div>
    <template v-if="isValidRole">
      <strong
        v-for="att in expert.attestations"
        :key="att.number + att.issued_at"
        class="is-flex is-size-5"
      >
        Свидетельство №{{ att.number }} от {{ att.issued_at | dateFormat }}
      </strong>
      <strong
        v-for="att in expert.certificates"
        :key="att.number + att.issued_at"
        class="is-flex is-size-5"
      >
        Сертификат №{{ att.number }} от {{ att.issued_at | dateFormat }}
      </strong>
    </template>
    <div>
      <strong class="is-size-5">
        В период проведения ДЭ
        <span
          v-if="isValidCertificate && isValidAttestation"
          class="has-text-success"
          >сертификат/свидетельство действуют</span
        >
        <span v-else-if="isValidCertificate" class="has-text-success"
          >сертификат действует</span
        >
        <span v-else-if="isValidAttestation" class="has-text-success"
          >свидетельство действует</span
        >
        <span
          class="has-text-danger"
          v-else
        >
          действующих сертификатов/свидетельств у эксперта нет
        </span>
        <br>
        <!-- <span
          v-if="!isValidRole"
          class="has-text-danger"
          >Эксперт заблокирован</span
        >
        -->
      </strong>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import expertTypes from '../demo-exams/data/expertTypesEnum'
import validateExpertCertificates from '@/utils/validate-expert-certificates'

export default {
  name: 'WsDemoExamsCertificateView',
  props: {
    expert: { type: Object, default: () => ({}) },
    exam_day_cm1: { type: String, default: '' },
    expertType: { type: String, default: '' }
  },
  filters: {
    dateFormat (value) {
      return moment(value).format('DD.MM.YYYY')
    }
  },
  data: () => ({ expertTypes }),
  computed: {
    isValidCertificate () {
      return validateExpertCertificates(this.expert.certificates, this.exam_day_cm1)
    },
    isValidAttestation () {
      return validateExpertCertificates(this.expert.attestations, this.exam_day_cm1)
    },
    isValidRole () {
      return (this.expertType === 'mainExpert' && this.expert.main_expert_role_status === 1) ||
        (this.expertType === 'linealExpert' && this.expert.lineal_expert_role_status === 1) ||
        (this.expertType === 'technicalExpert' && this.expert.technical_expert_role_status === 1)
    }
  }
}
</script>

<style></style>
